import type { ApplyEffectContext } from "./effectContext.js";

function hasIdle(ctx: ApplyEffectContext, allowTemporary: boolean): boolean {
  return ctx.run.hand.some((card) => card.cardId === "idle" && (allowTemporary || !card.temporaryForCase));
}

export function startPsychologicalCounseling(ctx: ApplyEffectContext): ApplyEffectContext {
  if (!hasIdle(ctx, false)) return ctx;
  return {
    ...ctx,
    run: {
      ...ctx.run,
      pendingChoice: { kind: "psychologicalCounseling", sourceInstanceId: ctx.sourceInstanceId, selected: [] },
    },
  };
}

export function startSpecialTaskTeam(ctx: ApplyEffectContext): ApplyEffectContext {
  if (!hasIdle(ctx, true)) return ctx;
  return {
    ...ctx,
    run: {
      ...ctx.run,
      pendingChoice: { kind: "specialTaskTeam", sourceInstanceId: ctx.sourceInstanceId, selected: [] },
    },
  };
}
